import type {
  SanityShopifyGlobalProduct,
  SanityGlobalProductVariant,
  SanityProductMediaImage,
} from '@repo/models/gatsby-graphql-types';

interface CustomProductVariant extends SanityGlobalProductVariant {
  barcode?: string;
}

interface CustomShopifyProduct extends SanityShopifyGlobalProduct {
  schemaDescription?: string;
  variants?: CustomProductVariant[];
}

const getProductSchema = (
  shopifyProduct: CustomShopifyProduct,
  activeSku: string
) => {
  if (!shopifyProduct) {
    return null;
  }

  const refurbished = false;

  const selectedVariant =
    shopifyProduct.variants.find(variant => variant.sku === activeSku) ||
    shopifyProduct.variants[0];

  const priceCurrency =
    shopifyProduct.priceRangeV2?.minVariantPrice?.currencyCode || 'USD';

  return {
    '@context': 'https://schema.org/',
    '@type': 'Product',
    '@id': typeof window !== 'undefined' ? window.location.href : '',
    name: shopifyProduct.title,
    image: shopifyProduct?.media
      ?.map(({ image }: SanityProductMediaImage) => image?.src)
      ?.filter(i => i)
      ?.at(0),
    description:
      shopifyProduct?.description || shopifyProduct.schemaDescription,
    sku: selectedVariant?.sku,
    gtin13: selectedVariant?.barcode,
    brand: {
      '@type': 'Brand',
      name: shopifyProduct?.vendor,
    },
    offers: {
      '@type': 'Offer',
      priceCurrency,
      price: selectedVariant?.price,
      itemCondition: refurbished
        ? 'https://schema.org/RefurbishedCondition'
        : 'https://schema.org/NewCondition',
      availability: selectedVariant?.availableForSale
        ? 'https://schema.org/InStock'
        : 'https://schema.org/OutOfStock',
    },
  };
};

export default getProductSchema;
